'use client';

import { ReactNode } from 'react';
import { IntercomContext } from './IntercomContext';
import { useIntercom } from './useIntercom';

interface IntercomProviderProps {
  children: ReactNode;
}

export const IntercomProvider = ({ children }: IntercomProviderProps) => {
  const { openIntercom } = useIntercom();

  // The useIntercom hook internally checks for appUser and firebaseUser
  // so it won't actually boot Intercom until those are available
  // It always returns an openIntercom function (even if Intercom isn't booted yet)

  return (
    <IntercomContext.Provider value={{ openIntercom }}>
      {children}
    </IntercomContext.Provider>
  );
};
